import { render, staticRenderFns } from "./massReducedModalDeposited.vue?vue&type=template&id=38575a82&scoped=true&"
import script from "./massReducedModalDeposited.vue?vue&type=script&lang=js&"
export * from "./massReducedModalDeposited.vue?vue&type=script&lang=js&"
import style0 from "./massReducedModalDeposited.vue?vue&type=style&index=0&id=38575a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38575a82",
  null
  
)

export default component.exports